import Actions from "./ComuniActions";
import { Comune } from "../generated";
import { AbstractStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";

export class ComuniStore extends AbstractStore<Comune> {
    searchedLocalities: { [index: string]: Comune[] } = {};
    constructor() {
        super(l => l.codFisComune);
        Dispatcher
            .onfunction(Actions.search, data => {
                this.searchedLocalities[data.searchValue.toLowerCase()] = data.comuni!;
                this.updateOrAddAll(data.comuni!);
            })
            .onfunction(Actions.get, data => data && this.updateOrAdd(data));
    }

    getSearchResult(search: string): Array<Comune> {
        return this.searchedLocalities[search.toLowerCase()] ?? [];
    }
}

export default new ComuniStore();